import WorthyApi from 'lib/api/worthyApi';

export const SCHEDULE_PICKUP = Symbol('SCHEDULE_PICKUP');
export const SCHEDULE_DROP_OFF = Symbol('SCHEDULE_DROP_OFF');
export const REQUEST_SHIPPING_KIT = Symbol('REQUEST_SHIPPING_KIT');

export function updateShipmentPreferences(itemId, preferences){
    let request =
        WorthyApi.updateShipmentPreferences(itemId, preferences);

    return {
        type:       null,
        payload:    request
    }
}

export function schedulePickup(itemId, readyTimestamp, companyCloseTime, dropOffLocations, expectFullResponse){
    let request =
        WorthyApi.schedulePickup(itemId, readyTimestamp, companyCloseTime, dropOffLocations, expectFullResponse)
            .then((res)=> {
                return res;
            })
            .catch((error)=>{
                throw error;
            });

    return {
        type:       expectFullResponse ? SCHEDULE_PICKUP : null,
        payload:    request
    }
}

export function scheduleDropOff(itemId, dropOffLocations, expectFullResponse) {
    let request =
        WorthyApi.handleDropOffSelected(itemId, dropOffLocations, true)
            .then(res => {
                return res
            })
            .catch(error => {
                throw error;
            });

    return {
        type:       expectFullResponse ? SCHEDULE_DROP_OFF : null,
        payload:    request
    }
}

export function requestShippingKit(itemId) {
    let request =
        WorthyApi.requestShippingKit(itemId)
            .then(res => {
                return res
            })
            .catch(error => {
                throw error;
            });

    return {
        type:       REQUEST_SHIPPING_KIT,
        payload:    request
    }
}
